import type { SVGProps } from 'react';

export default function Briefcase(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 14.25H10.75V12.75H10V14.25ZM6.75 8.5H17.25V7H6.75V8.5ZM17.25 18.5H6.75V20H17.25V18.5ZM6.75 18.5C6.05964 18.5 5.5 17.9404 5.5 17.25H4C4 18.7688 5.23122 20 6.75 20V18.5ZM18.5 17.25C18.5 17.9404 17.9404 18.5 17.25 18.5V20C18.7688 20 20 18.7688 20 17.25H18.5ZM17.25 8.5C17.9404 8.5 18.5 9.05964 18.5 9.75H20C20 8.23122 18.7688 7 17.25 7V8.5ZM6.75 7C5.23122 7 4 8.23122 4 9.75H5.5C5.5 9.05964 6.05964 8.5 6.75 8.5V7ZM18.5 9.75V13.5H20V9.75H18.5ZM18.5 13.5V17.25H20V13.5H18.5ZM19.25 12.75H14V14.25H19.25V12.75ZM5.5 17.25V13.5H4V17.25H5.5ZM5.5 13.5V9.75H4V13.5H5.5ZM4.75 14.25H10V12.75H4.75V14.25ZM9.5 7.5V6.75H8V7.5H9.5ZM10.75 5.5H13.25V4H10.75V5.5ZM14.5 6.75V7.5H16V6.75H14.5ZM13.25 5.5C13.9404 5.5 14.5 6.05964 14.5 6.75H16C16 5.23122 14.7688 4 13.25 4V5.5ZM9.5 6.75C9.5 6.05964 10.0596 5.5 10.75 5.5V4C9.23122 4 8 5.23122 8 6.75H9.5ZM12.75 13.3999C12.75 13.8141 12.4142 14.1499 12 14.1499V15.6499C13.2426 15.6499 14.25 14.6425 14.25 13.3999H12.75ZM12 14.1499C11.5858 14.1499 11.25 13.8141 11.25 13.3999H9.75C9.75 14.6425 10.7574 15.6499 12 15.6499V14.1499ZM11.25 13.3999C11.25 12.9857 11.5858 12.6499 12 12.6499V11.1499C10.7574 11.1499 9.75 12.1573 9.75 13.3999H11.25ZM12 12.6499C12.4142 12.6499 12.75 12.9857 12.75 13.3999H14.25C14.25 12.1573 13.2426 11.1499 12 11.1499V12.6499Z"
        fill="currentColor"
      />
    </svg>
  );
}
